import React from 'react';
import PropTypes from 'prop-types';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import Loading from 'Components/Loading';
import loadable from '@loadable/component';

const MailPrivacyPolicy = loadable(() => pMinDelay(import('./MailPrivacyPolicy'), 300), {
  fallback: <Loading />
});

const AsyncMailPrivacyPolicy = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <MailPrivacyPolicy { ...props } helmet={ pageConfig.helmet } />
    </ApplicationLayout>
  );
};

AsyncMailPrivacyPolicy.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncMailPrivacyPolicy;
